import { render, staticRenderFns } from "./ItemProdutoAfiliadoList.vue?vue&type=template&id=6f917d02&scoped=true&"
import script from "./ItemProdutoAfiliadoList.vue?vue&type=script&lang=js&"
export * from "./ItemProdutoAfiliadoList.vue?vue&type=script&lang=js&"
import style0 from "./ItemProdutoAfiliadoList.vue?vue&type=style&index=0&id=6f917d02&prod&lang=scss&scoped=true&"
import style1 from "./ItemProdutoAfiliadoList.vue?vue&type=style&index=1&id=6f917d02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f917d02",
  null
  
)

export default component.exports